module.exports = __webpack_public_path__ + "img/0Q3A7263_L_Wood_MockedUp.6025cb8d.jpg";